<div (click)="GoToFicheProduit(produit)" id="CarteProduit" *ngFor="let produit of Produits">
    <div *ngIf="produit.actif">
        <img src="{{produit.imageUrl}}" alt="PhotoProduit" id="PhotoProduit">
        <br>
        <p id="TxtNomProduit">{{produit.nom}}</p>
        <p id="TxtPrixProduit">à partir de <br>{{produit.prix}} €</p>
        <br>
        <a class="TxtFicheProduit">VOIR LE PRODUIT</a>
    </div>
</div>